import { render, staticRenderFns } from "./comUserAdd.vue?vue&type=template&id=f8457588&scoped=true&"
import script from "./comUserAdd.vue?vue&type=script&lang=js&"
export * from "./comUserAdd.vue?vue&type=script&lang=js&"
import style0 from "./comUserAdd.vue?vue&type=style&index=0&id=f8457588&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8457588",
  null
  
)

export default component.exports